@let _href = href();
@let _displayText = displayText();
@let _hrefClass = hrefClass();
@let _isValidEmail = isValidEmail();

@if (_isValidEmail) {
  <a
    [href]="_href"
    [class]="`${_hrefClass}`"
    (click)="$event.stopPropagation()"
  >
    {{ _displayText }}
  </a>
} @else {
  {{ _displayText }}
}
